import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "react-feather";
import AppContext from "../../../../context/AppContext";

import "./stylesSiderTab.css";

const SiderTab = ({
  unselectedIcon,
  selectedIcon,
  tabName,
  onPress,
  dropdownOptions = [],
}) => {
  const {
    selectedSiderTab,
    selectedDropdownOption,
    setSelectedDropdownOption,
  } = useContext(AppContext);
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (dropdownOptions.some((option) => option.label === selectedDropdownOption)) {
      setIsDropdownOpen(true);
    }
  }, [selectedDropdownOption, dropdownOptions]);

  const handleTabClicked = () => {
    if (dropdownOptions.length > 0) {
      onPress();
      setIsDropdownOpen((prev) => !prev);
    } else {
      setSelectedDropdownOption(null);
      setIsDropdownOpen(false);
      onPress();
    }
  };

  const handleOptionClick = (option) => {
    setSelectedDropdownOption(option.label);
    navigate(option.navigate);
  };

  return (
    <div className={`sider-tab-container ${selectedSiderTab === tabName ? "selected" : ""}`}>
      <button
        className={selectedSiderTab === tabName ? "sider-tab-selected" : "sider-tab"}
        onClick={handleTabClicked}
      >
        <div className="tab-content">
          <img
            className="tab-icon"
            src={selectedSiderTab === tabName ? selectedIcon : unselectedIcon}
            alt="icon"
          />
          <div className={selectedSiderTab === tabName ? "tab-label-selected" : "tab-label-unselected"}>
            {tabName}
          </div>
        </div>

        {dropdownOptions.length > 0 && (
          <span className="dropdown-toggle">
            {isDropdownOpen ? <ChevronUp /> : <ChevronDown />}
          </span>
        )}
      </button>

      {isDropdownOpen && dropdownOptions.length > 0 && (
        <div className="dropdown-menu">
          {dropdownOptions.map((option, index) => (
            <div
              key={index}
              className={`dropdown-option ${selectedDropdownOption === option.label ? "selected" : ""}`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SiderTab;
